import React, { useState, useRef, useEffect } from "react";
import MRMSLogo from "../../../src/assets/Images/LoginImages/MRMSLogo.png";
import PoweredBy from '../../../src/assets/Images/LoginImages/PoweredBy.png';
import { useNavigate, useSearchParams } from "react-router-dom";
import { addLoginResponse } from "../../features/login/loginSlice";
import { useDispatch } from "react-redux";
import APICom from "../../utils/helpers/APICom";
import ModuleSecurity from "../../utils/helpers/ModuleSecurity";
import PersistStorage from '../../utils/helpers/PersistStorage';

const LoginAuto = () => {

    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [Message, setMessage] = useState("Performing Auto Login, Please wait...");
    let _username = searchParams.get("u");
    let _password = searchParams.get("p");
    let _ext = searchParams.get("ext");
    let _station = searchParams.get("station");
    let _vMethod = searchParams.get("method");
    let _applicationsessionid = searchParams.get("applicationsessionid");
    let _useriplist = searchParams.get("useriplist");
    let _route = searchParams.get("rpgname");
    let _AffID = searchParams.get("affID");
    //Form values
    const [login, setLogin] = useState({vUserName: _username, vPassword: _password, vExtension: _ext, errorMsg: '', vStation: _station, vMethod: _vMethod, vApplicationSessionID: _applicationsessionid, vUserIPList: _useriplist, vRoute: _route, iAffID: _AffID, isLogin: false});
    const navigate = useNavigate();
    const signInButton = useRef(null);

    const InitiateLogin = async () => {
        setLogin({ ...login, errorMsg: "", isLogin: false }); 
        if(!login.vUserName || !login.vPassword)
        {
            setMessage("Auto login failed due to missing parameters. Please contact backoffice.");
        }
        else
        {
            const userIPResponse = await APICom.fetchData("full", 'https://api.ipify.org?format=json', "get", {}, {});
            let userIP = "";
            if(userIPResponse && userIPResponse.error === '')
            {
                if(userIPResponse.data.ip && userIPResponse.data.ip.length > 0)
                {
                    userIP = userIPResponse.data.ip;
                }
                else
                {
                    userIP = "50.204.237.2";
                }
            }
            else
            {
                userIP = "50.204.237.2";
            }

            const data = {
                "vUserName": login.vUserName,
                "vPassword": login.vPassword,
                "vStation": String(userIP)+"/"+String(userIP),
                "vMethod": "MRMS-MRMSDispatchAutoLogin",
                "vApplicationSessionID": "WebMRMS-chrome_114-Windows@Time_21/7/2023 @ 16:42:55",
                "vExtension": login.vExtension === ""? 1:login.vExtension,
                "vUserIPList":String(userIP)
            }
            try
            {
                const response = await APICom.fetchData("main", "AuthActions/GetUserValidation", "post", {}, data);
                if (response.error !== "") {
                    setMessage(response.error);
                }
                else if(response.data[0].hasOwnProperty("MSG"))
                {
                    setMessage(response.data[0].MSG);
                }
                else
                {
                    if(response.data[0].IsPowerUser === true){
                        await ModuleSecurity.PowerUserModules(response.data[0].iUserID, response.data[0].recordID);
                    }
                    else {
                        await ModuleSecurity.FetchAndSaveUserAssignedModules(response.data[0].iUserID, response.data[0].recordID);
                    }
                    setLogin({ ...login, errorMsg:'', isLogin: true });
                    dispatch(addLoginResponse(response.data[0]));
                    if(login.vRoute === "CallAgent")
                    {
                        PersistStorage.save("affSelectedCallAgent", login.iAffID, 999, true);
                        navigate('/CallAgent');
                    }
                    else
                    {
                        navigate('/Dispatch');
                    }

                }    
            }catch(e)
            {
                console.log(e);
            }
            
        }
    }
    useEffect(() => {
        InitiateLogin();
    }, []);
    if (!login.isLogin)
    {

        return(
            <div>{Message}</div>
        )
    }
    else{
        return(
            <div>{Message}</div>
        )
    }

};


export default LoginAuto;